module.exports = {
	name: 'decimal',
	validation(yup) {
		return yup.number().max(2147483647);
	}
};
